import { Trans } from '@lingui/macro'
import React from 'react'
import { FlexEnd, FlexOne, Paper, Typography } from 'webbook-airways'
import { ReadMore } from './'

export default function Introduction({
  minHeight = 375,
  title,
  illustration: Illustration,
  onClick
}) {
  return (
    <Paper minHeight={minHeight} onClick={onClick}>
      <FlexOne />
      <Typography align="center" variant="subtitle1">
        <Trans>Introduction to</Trans>
      </Typography>
      <Typography variant="h5" align="center" style={{ fontWeight: 500 }}>
        {title}
      </Typography>
      {Illustration && (
        <Illustration style={{ margin: '0 auto', width: 250, height: 250 }} />
      )}
      <FlexOne />
      <FlexEnd>
        <ReadMore title={<Trans>Get started</Trans>} />
      </FlexEnd>
    </Paper>
  )
}
